/*  MUI  */
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const INTEGRATION_OPTION_NONE = 'none';
export const INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_MANUAL =
    'microsoftEntraIDManual';
export const INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED =
    'microsoftEntraIDAutomated';
export const INTEGRATION_OPTION_GOOGLE_AUTOMATED = 'googleAutomated';

const DEFAULT_INTEGRATION_OPTIONS = [
    INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED,
    INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_MANUAL,
    INTEGRATION_OPTION_GOOGLE_AUTOMATED,
    INTEGRATION_OPTION_NONE
];

export const IntegrationSelector = ({
    selectedIntegrationType,
    setIntegrationType,
    integrationOptions = DEFAULT_INTEGRATION_OPTIONS
}) => {
    const { t } = useTranslation();

    return (
        <Box mx="24px" mb="24px" paddingTop="0" paddingLeft="0">
            <RadioGroup
                row
                value={selectedIntegrationType}
                onChange={(e) => setIntegrationType(e.currentTarget.value)}
            >
                {integrationOptions.map((integrationOption) => (
                    <FormControlLabel
                        key={integrationOption}
                        value={integrationOption}
                        control={<Radio />}
                        label={t(
                            `Clients.addModal.integrationType.${integrationOption}`
                        )}
                    />
                ))}
            </RadioGroup>
        </Box>
    );
};
